'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fishrmnComponents = require('@fishrmn/fishrmn-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Component name
// propFields : map (prop path -> data object field)

var componentTypes = {
  Location: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.Location, props);
    },
    requiredProps: ['address', 'name'],
    fixedProps: {}
  },
  Call: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.Call, props);
    },
    requiredProps: ['number'],
    fixedProps: {}
  },
  Hoo: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.Hoo, props);
    },
    requiredProps: ['hours', 'timezone'],
    fixedProps: {}
  },
  Title: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(
        _fishrmnComponents.TitleBanner,
        props,
        _react2.default.createElement(
          'h2',
          null,
          props.title
        )
      );
    },
    requiredProps: ['title'],
    fixedProps: {}
  },
  PageTitle: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(
        _fishrmnComponents.TitleBanner,
        props,
        _react2.default.createElement(
          'h1',
          null,
          props.title
        )
      );
    },
    requiredProps: ['title'],
    fixedProps: {}
  },
  SocialMedia: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.SocialMediaButtons, props);
    },
    requiredProps: ['socialMediaConfig'],
    fixedProps: {}
  },
  Tagline: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.Tagline, props);
    },
    requiredProps: ['headerText', 'tagline'],
    fixedProps: {}
  },
  ImageGallery: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.ImageGallery, props);
    },
    requiredProps: ['images'],
    fixedProps: {}
  },
  Contact: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.ContactForm, props);
    },
    requiredProps: ['subscriptionCallback'],
    fixedProps: {}
  },
  Reviews: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.Reviews, props);
    },
    requiredProps: ['reviews'],
    fixedProps: {}
  },
  Email: {
    getComponent: function getComponent(props) {
      return _react2.default.createElement(_fishrmnComponents.Email, props);
    },
    requiredProps: ['email'],
    fixedProps: {}
  }
};

exports.default = componentTypes;